import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(cartLinkStyles, {
    ...cartLinkStyles,
    routerLink: {
        typographyProps: {
            variant: "headerSecondary",
            size: 15,
            css: css`
                > span {
                    font-size: 12px;
                }
            `,
        },
        icon: {
            iconProps: {
                size: 22,
            },
        },
        color: `${CarotekColors.blue1}`,
        css: css`
            padding: 6px 0;
            padding-left: 10px;

            :hover {
                span,
                svg {
                    color: ${getColor("danger")};
                }
            }
        `,
    },
    desktopCountText: {
        color: `${CarotekColors.blue1}`,
    },
});
